import React from 'react';
import { Link } from 'react-router-dom';
import { visitFAQs } from '../data/visit';
import BookAppointmentLink from './BookAppointmentLink';

export default function DentalVisitAnswers() {
  return (
    <section className="bg-white py-12" aria-labelledby="dental-visit-answers">
      <div className="container-custom max-w-4xl">
        <h2 id="dental-visit-answers" className="text-3xl font-bold text-primary mb-8 font-nantes">
          Planning your pet’s dental visit in Fort Lauderdale
        </h2>
        <dl className="space-y-6">
          {visitFAQs.map(({ question, answer }) => (
            <div key={question}>
              <dt className="text-lg font-semibold text-gray-900 mb-2">{question}</dt>
              <dd className="text-base text-gray-700 leading-relaxed">{answer}</dd>
            </div>
          ))}
        </dl>
        <div className="flex flex-wrap gap-x-6 gap-y-3 mt-8 text-base">
          <Link className="text-brand-teal underline" to="/blog/pet-dental-cleaning-cost-fort-lauderdale">Read the itemized cost guide</Link>
          <Link className="text-brand-teal underline" to="/team">Meet the veterinary team</Link>
          <Link className="text-brand-teal underline" to="/contact">Clinic directions and contact</Link>
          <BookAppointmentLink analyticsSource="service_page" className="text-brand-teal underline">Request an appointment</BookAppointmentLink>
        </div>
      </div>
    </section>
  );
}
